import { useEffect } from 'react';
import { useSpring } from 'react-spring';

function useHeroItemSpring({ container }) {
  const [{ offset }, setOffset] = useSpring(() => ({ offset: 0 }));

  const handleScroll = () => {
    const posY = container.current.getBoundingClientRect().top;
    const offset = window.pageYOffset - posY;

    setOffset({ offset });
  };

  useEffect(() => {
    window.addEventListener('scroll', handleScroll);

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  });

  const calc = (o) => `translateY(${o * 0.05}px)`;

  return { calc, handleScroll, offset, setOffset };
}

export default useHeroItemSpring;
